import React from 'react';
import { StarIcon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
import { useWebinarSlot } from './useWebinarSlot';
export const FinalCTA = () => {
  const {
    openPopup
  } = useRegistration();
  const slot = useWebinarSlot();
  return <section className="mb-12" data-id="element-220">
      <div className="bg-red-50 border-2 border-red-400 rounded-lg p-4 mb-6 text-center" data-id="element-221">
        <p className="text-red-700 font-bold text-lg" data-id="element-222">⚠️ BEPERKTE PLEKKEN ⚠️</p>
      </div>

      <div className="bg-white border-2 border-green-500 rounded-lg p-8 text-center" data-id="element-223">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-224">
          Leer vandaag nog "Communiceren met je Hond"
        </h2>

        <p className="text-lg text-gray-700 mb-2" data-id="element-225">
          {slot.dayPrefix} {slot.dateLabel} • {slot.time}
        </p>

        <div className="inline-block bg-green-500 text-white px-6 py-2 rounded-full font-bold text-2xl mb-6" data-id="element-226">
          GRATIS
        </div>

        <p className="text-sm text-gray-600 mb-6" data-id="element-227">Geen verborgen kosten</p>

        <button onClick={openPopup} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-5 px-8 rounded-lg transition-colors text-xl mb-6 animate-pulse" data-id="element-228">
          JA, IK WIL MIJN HOND EINDELIJK BEGRIJPEN - GRATIS AANMELDEN
        </button>

        <p className="text-gray-700 leading-relaxed mb-4" data-id="element-229">
          In 90 minuten van frustratie naar begrip, van gissen naar weten, van
          reageren naar communiceren
        </p>

        <div className="flex items-center justify-center" data-id="element-230">
          <div className="flex mr-2" data-id="element-231">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-232" />)}
          </div>
          <span className="text-sm font-semibold text-gray-700" data-id="element-233">
            Meer dan 100.000 deelnemers in 2025
          </span>
        </div>
      </div>

      <p className="text-center text-lg font-semibold text-gray-800 mt-8" data-id="element-234">
        Want soms kan anderhalf uur alles veranderen.
      </p>
    </section>;
};